module.exports = __webpack_public_path__ + "img/loud_viewer_4.005f9c30.png";